function toCents(value) {
  if (value === "" || value === null || value === undefined) return 0;
  var num = Number(value);
  if (isNaN(num)) return 0;
  return Math.round(num * 100);
}

function fromCents(value) {
  if (value === null || value === undefined || value === 0) return "";
  return String(value / 100);
}

export { toCents, fromCents };
